import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 样式
import '@/assets/css/publicReset.less'
import veGameSDK from './VeGameSDK-Web_1.48.1.js';
window.veGameSDK = veGameSDK;
import { DatetimePicker, Uploader, ImagePreview, CountDown, NoticeBar,Circle, Picker} from 'vant';
Vue.use(DatetimePicker).use(Uploader).use(ImagePreview).use(CountDown).use(NoticeBar).use(Circle).use(Picker);
// loading
import Loading from './util/loading.js'
Vue.prototype.$loadinges = Loading
Vue.use(ElementUI); // 使用 Element UI
// 全局注册自定义过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
